const UploadFileIconSVG = ({ className, parentClassName }) => (
  <svg
    width="26"
    height="31"
    viewBox="0 0 26 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 9.04169C26 8.69935 25.8634 8.37015 25.6191 8.12842L17.8191 0.37842C17.5759 0.135728 17.2446 0 16.9 0H1.3C0.582465 0 0 0.578725 0 1.29167V29.7083C0 30.4213 0.582458 31 1.3 31H24.7C25.4175 31 26 30.4213 26 29.7083L26 9.04169ZM6.50002 24.5417H19.5C20.2175 24.5417 20.8 23.963 20.8 23.25C20.8 22.5371 20.2175 21.9584 19.5 21.9584H6.50002C5.78249 21.9584 5.20002 22.5371 5.20002 23.25C5.20002 23.963 5.78248 24.5417 6.50002 24.5417ZM6.50002 19.375H19.5C20.2175 19.375 20.8 18.7963 20.8 18.0834C20.8 17.3704 20.2175 16.7917 19.5 16.7917H6.50002C5.78249 16.7917 5.20002 17.3704 5.20002 18.0834C5.20002 18.7963 5.78248 19.375 6.50002 19.375ZM6.50002 14.2084H14.3C15.0175 14.2084 15.6 13.6296 15.6 12.9167C15.6 12.2038 15.0176 11.625 14.3 11.625H6.50002C5.78249 11.625 5.20002 12.2038 5.20002 12.9167C5.20002 13.6296 5.78248 14.2084 6.50002 14.2084Z"
      className={`${className} notification-SVG`}
    />
  </svg>
);

const DownloadAllFileIconSVG = ({ className, parentClassName }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26995 6.19738H11.5557L7.55566 10.315L3.55566 6.19738H5.84138V2.66797H9.26995V6.19738ZM3.55566 12.6674V11.4909H11.5557V12.6674H3.55566Z"
      className={`${className} sidenav-SVG`}
    />
  </svg>
);

const IconSVG = ({ className, parentClassName }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26995 6.19738H11.5557L7.55566 10.315L3.55566 6.19738H5.84138V2.66797H9.26995V6.19738ZM3.55566 12.6674V11.4909H11.5557V12.6674H3.55566Z"
      className={`${className} downloadFile-SVG`}
    />
  </svg>
);

const SendDocumentIconSVG = ({ className, parentClassName }) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      d="M7.25431 7.96486L1.53887 8.53564L0.0345806 13.499C-0.0242917 13.6915 -0.00751413 13.9002 0.0812512 14.08C0.170017 14.2599 0.323909 14.3965 0.509382 14.4604C0.694999 14.5243 0.897393 14.5105 1.07312 14.4219L13.5996 8.16324C13.7605 8.08236 13.886 7.94182 13.9512 7.76982C14.0163 7.59781 14.0163 7.40676 13.9512 7.23476C13.886 7.06276 13.7605 6.92222 13.5996 6.84133L1.08171 0.578296C0.906003 0.489539 0.703456 0.475688 0.517854 0.539582C0.33239 0.603631 0.178649 0.740233 0.0897238 0.919949C0.000958493 1.09982 -0.0158191 1.3085 0.0430532 1.50097L1.54735 6.46435L7.25224 7.03513C7.4827 7.05874 7.65839 7.25876 7.65839 7.49763C7.65839 7.73668 7.48269 7.93668 7.25224 7.96013L7.25431 7.96486Z"
      className={`${className} sidenav-SVG`}
    />
  </svg>
);

const IconDisabledSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26995 6.19738H11.5557L7.55566 10.315L3.55566 6.19738H5.84138V2.66797H9.26995V6.19738ZM3.55566 12.6674V11.4909H11.5557V12.6674H3.55566Z"
      fill="#999999"
    />
  </svg>
);

const SendDocumentDisabledIconSVG = ({ className, parentClassName }) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.25431 7.96486L1.53887 8.53564L0.0345806 13.499C-0.0242917 13.6915 -0.00751413 13.9002 0.0812512 14.08C0.170017 14.2599 0.323909 14.3965 0.509382 14.4604C0.694999 14.5243 0.897393 14.5105 1.07312 14.4219L13.5996 8.16324C13.7605 8.08236 13.886 7.94182 13.9512 7.76982C14.0163 7.59781 14.0163 7.40676 13.9512 7.23476C13.886 7.06276 13.7605 6.92222 13.5996 6.84133L1.08171 0.578296C0.906003 0.489539 0.703456 0.475688 0.517854 0.539582C0.33239 0.603631 0.178649 0.740233 0.0897238 0.919949C0.000958493 1.09982 -0.0158191 1.3085 0.0430532 1.50097L1.54735 6.46435L7.25224 7.03513C7.4827 7.05874 7.65839 7.25876 7.65839 7.49763C7.65839 7.73668 7.48269 7.93668 7.25224 7.96013L7.25431 7.96486Z"
      fill="#999999"
      className={`${className} sidenav-SVG`}
    />
  </svg>
);

const FacilityProviderIconSVG = ({ className }) => (
  <svg
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18.5" cy="18.5" r="18" fill="#EDE4F1" />
    <path
      d="M21.3125 15.125H19.0625V12.875H17.9375V15.125H15.6875V16.25H17.9375V18.5H19.0625V16.25H21.3125V15.125Z"
      className={className}
    />
    <path
      d="M25.25 15.125H24.125V11.75C24.1247 11.4517 24.0061 11.1657 23.7952 10.9548C23.5843 10.7439 23.2983 10.6253 23 10.625H14C13.7017 10.6253 13.4157 10.7439 13.2048 10.9548C12.9939 11.1657 12.8753 11.4517 12.875 11.75V15.125H11.75C11.4517 15.1253 11.1657 15.2439 10.9548 15.4548C10.7439 15.6657 10.6253 15.9517 10.625 16.25V26.375H26.375V16.25C26.3747 15.9517 26.2561 15.6657 26.0452 15.4548C25.8343 15.2439 25.5483 15.1253 25.25 15.125ZM17.375 25.25V21.875H19.625V25.25H17.375ZM20.75 25.25V21.3125C20.75 21.1633 20.6907 21.0202 20.5852 20.9148C20.4798 20.8093 20.3367 20.75 20.1875 20.75H16.8125C16.6633 20.75 16.5202 20.8093 16.4148 20.9148C16.3093 21.0202 16.25 21.1633 16.25 21.3125V25.25H11.75V16.25H14V11.75H23V16.25H25.25V25.25H20.75Z"
      className={className}
    />
  </svg>
);

const DoctorProviderIconSVG = ({ className }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#EDE4F1" />
    <path
      d="M23.6938 20.8565C23.3117 19.4455 22.5536 18.65 21.1375 18.2447C21.1375 18.2447 20.1398 17.9399 19.318 17.6656C19.0758 17.3737 18.7169 17.2049 18.3385 17.2054H18.2294C18.1887 17.0131 18.1703 16.8168 18.1748 16.6202C18.693 16.092 19.0426 15.4202 19.1785 14.691C19.4884 14.552 19.7239 14.2855 19.8244 13.9596C19.9458 13.6775 19.9651 13.3615 19.879 13.0666C20.5341 11.4695 20.3278 9.51607 19.4332 8.8882C18.9878 8.03298 18.2036 7.40645 17.274 7.16332C16.0705 6.82537 14.7809 7.01704 13.7262 7.69057C10.7786 9.59836 11.9279 12.64 12.1584 13.1764C12.1113 13.4403 12.141 13.7121 12.2433 13.9596C12.3454 14.2797 12.5781 14.5412 12.8831 14.6789C13.0118 15.3761 13.3371 16.0213 13.8202 16.538C13.8284 16.7621 13.8079 16.9865 13.7595 17.2054C13.4012 17.201 13.058 17.3507 12.8165 17.6169C12.2585 17.7998 11.5277 18.0314 10.8454 18.2447C9.42926 18.6501 8.66505 19.4455 8.28289 20.8566C8.28289 20.9023 8.26172 20.945 8.25253 20.9907L7.99785 22.4261V22.4537C7.96528 22.8175 8.08744 23.1782 8.33427 23.4465C8.58095 23.7148 8.92919 23.8657 9.29271 23.8617H9.77187L9.70509 24.2822C9.6663 24.5336 9.74078 24.7894 9.90824 24.9802C10.1112 25.1857 10.3907 25.2962 10.6785 25.2849H11.0971C11.2645 25.2849 11.4003 25.1485 11.4003 24.9802C11.4003 24.8118 11.2645 24.6754 11.0971 24.6754H10.6695C10.5492 24.6828 10.4311 24.641 10.3419 24.5595C10.2932 24.4977 10.2723 24.4181 10.2843 24.3401L10.3662 23.8373H15.1635L15.2484 24.3432C15.2607 24.4099 15.2417 24.4784 15.197 24.5291C15.1099 24.6229 14.9879 24.6758 14.8603 24.6754H14.4389C14.2713 24.6754 14.1357 24.8118 14.1357 24.9802C14.1357 25.1485 14.2713 25.2849 14.4389 25.2849H14.8604C15.163 25.2883 15.4517 25.1592 15.6519 24.9313C15.8096 24.7467 15.8764 24.5005 15.8337 24.2608L15.7669 23.8554L22.693 23.8555C23.0564 23.86 23.4048 23.7094 23.6513 23.4409C23.897 23.1717 24.0191 22.8113 23.9879 22.4475L23.7211 20.9693L23.6938 20.8565ZM19.3119 20.823C19.4936 20.823 19.6681 20.8956 19.7966 21.0248C19.9252 21.154 19.9973 21.3291 19.9973 21.5117C19.9973 21.6945 19.9252 21.8696 19.7966 21.9988C19.6681 22.1279 19.4937 22.2006 19.312 22.2006C19.1302 22.2006 18.9559 22.128 18.8274 21.9988C18.6989 21.8696 18.6266 21.6945 18.6266 21.5117C18.6266 21.3291 18.6989 21.154 18.8274 21.0248C18.9559 20.8956 19.1301 20.823 19.3119 20.823ZM19.2604 13.7554C19.21 13.9151 19.1019 14.0501 18.9573 14.1333L18.654 14.0632L19.1483 13.4048C19.1869 13.3475 19.2375 13.2998 19.2968 13.2648C19.3415 13.4276 19.3285 13.6009 19.2604 13.7554ZM14.0355 8.20556C14.9453 7.62578 16.0567 7.45971 17.0951 7.74841C17.8881 7.95436 18.5523 8.49738 18.9146 9.23564L18.954 9.31794L19.0328 9.36675C19.6393 9.71423 19.8757 11.2745 19.3815 12.6613C19.3342 12.6537 19.2863 12.6537 19.239 12.6613C19.3148 12.2163 19.4453 11.1649 19.0964 10.6315C18.9861 10.4599 18.811 10.341 18.6114 10.3023L18.3354 10.2444L18.2656 10.5187C18.1322 11.0369 17.6591 11.0733 16.1429 11.11H15.8003C14.6146 11.1434 12.8255 11.1923 12.8255 12.5911V12.6734C12.7448 12.6536 12.6605 12.6536 12.5798 12.6734C12.2858 11.8658 11.7702 9.66849 14.0355 8.20556ZM13.0832 14.1333C12.9344 14.0551 12.8247 13.9181 12.78 13.7555C12.7068 13.6028 12.6897 13.429 12.7314 13.2649C12.7907 13.2998 12.8414 13.3477 12.8801 13.405L13.3774 14.0663L13.0832 14.1333ZM13.4137 14.1059V12.5821C13.4137 11.8993 14.2931 11.741 15.8124 11.6983H16.1551C17.4589 11.6648 18.2778 11.6434 18.6598 11.0888C18.8024 11.4849 18.7205 12.2865 18.6233 12.7437V14.1274L18.6384 14.1061L18.6112 14.4108C18.4899 15.7366 17.2284 17.0349 16.0609 17.0349H15.9821C14.8177 17.0349 13.5562 15.7366 13.4318 14.4108L13.4137 14.1059ZM9.28354 23.2643C9.08809 23.2684 8.9002 23.1893 8.76621 23.0464C8.6322 22.9035 8.56454 22.7104 8.57993 22.5145L8.83772 21.0974L8.85594 21.0121C9.18643 19.7931 9.78996 19.1835 11.0151 18.8147L12.4798 18.3546C12.4767 18.3982 12.4765 18.442 12.4796 18.4856V20.2441C11.8609 20.3079 11.2803 20.5752 10.8279 21.0044C10.3756 21.4337 10.0768 22.001 9.97787 22.6183L9.8717 23.2644L9.28354 23.2643ZM10.4632 23.2643L10.5511 22.7126C10.6361 22.1855 10.9047 21.7062 11.3091 21.3599C11.7136 21.0138 12.2274 20.8234 12.7587 20.8231C13.291 20.8221 13.8061 21.0117 14.2118 21.358C14.6175 21.7043 14.8872 22.1846 14.9723 22.7128L15.0603 23.2644L10.4632 23.2643ZM23.2146 23.0418C23.0796 23.1866 22.8902 23.2673 22.693 23.2643H15.6698L15.5789 22.6183C15.48 22.001 15.1812 21.4337 14.729 21.0044C14.2766 20.5752 13.6961 20.308 13.0771 20.2441V18.4856C13.069 18.3619 13.0952 18.2384 13.153 18.129C13.4467 18.0444 13.7353 17.9426 14.0172 17.8243C14.0551 17.8018 14.0891 17.7729 14.1173 17.7389C14.1267 17.7335 14.135 17.7262 14.1415 17.7176C14.1504 17.7058 14.1583 17.6936 14.1658 17.681C14.1797 17.6656 14.1909 17.6482 14.1992 17.6292C14.2947 17.4576 14.3526 17.2674 14.3689 17.0714C14.8371 17.4176 15.4011 17.6082 15.9822 17.617H16.061C16.6142 17.6039 17.1508 17.4244 17.6015 17.1019C17.619 17.3148 17.6933 17.5192 17.8168 17.6931L17.835 17.7144C17.867 17.7509 17.9037 17.7826 17.9442 17.8089C18.1817 17.9213 18.4282 18.0131 18.6811 18.0832L18.9297 18.1655C18.9821 18.2588 19.0111 18.3634 19.0147 18.4702V20.2532C18.6079 20.3535 18.2763 20.6481 18.1275 21.0416C17.9786 21.4349 18.0317 21.8767 18.2695 22.2232C18.5071 22.5696 18.8992 22.7765 19.3179 22.7765C19.7367 22.7765 20.1286 22.5696 20.3664 22.2232C20.604 21.8767 20.6572 21.4349 20.5084 21.0416C20.3596 20.6481 20.0279 20.3535 19.6212 20.2532V18.4825V18.385L20.9887 18.8177C22.2017 19.1682 22.8082 19.7838 23.1387 20.9999L23.4176 22.5238C23.4243 22.7172 23.3508 22.905 23.2146 23.0418Z"
      className={className}
    />
  </svg>
);

const DeleteIconSVG = ({ className, parentClassName }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    className={parentClassName}
  >
    <path
      d="M10.4075 3.76533L10.0412 14.1597C10.0389 14.2266 9.97774 14.2875 9.91218 14.2875H3.39873C3.33441 14.2875 3.27202 14.2253 3.26967 14.1597L2.90344 3.76533C2.88966 3.37168 2.56916 3.064 2.18778 3.07838C1.80627 3.09274 1.50833 3.42342 1.52226 3.81723L1.88836 14.2116C1.91769 15.0442 2.59051 15.7141 3.39872 15.7141H9.91218C10.7216 15.7141 11.3931 15.0458 11.4225 14.2116L11.7886 3.81723C11.8026 3.42344 11.5046 3.09276 11.1231 3.07838C10.7418 3.06402 10.4213 3.37167 10.4075 3.76533H10.4075Z"
      className={className}
    />
    <path
      d="M6.02484 5.81946V12.7856C6.02484 13.0684 6.26684 13.2978 6.56523 13.2978C6.86362 13.2978 7.10561 13.0684 7.10561 12.7856V5.81946C7.10561 5.53662 6.86362 5.30724 6.56523 5.30724C6.26684 5.30724 6.02484 5.53662 6.02484 5.81946Z"
      className={className}
    />
    <path
      d="M3.86391 5.83454L4.04408 12.8006C4.05136 13.0835 4.2588 13.3059 4.50743 13.2976C4.75595 13.2893 4.95158 13.0533 4.94428 12.7705L4.76411 5.80439C4.75682 5.5217 4.54939 5.29916 4.30076 5.30747C4.05224 5.31576 3.85661 5.55171 3.86391 5.83454Z"
      className={className}
    />
    <path
      d="M8.36634 5.80439L8.18617 12.7705C8.17888 13.0533 8.37451 13.2893 8.62302 13.2976C8.87167 13.3059 9.07911 13.0835 9.08638 12.8006L9.26655 5.83454C9.27383 5.5517 9.07821 5.31574 8.8297 5.30747C8.58105 5.29918 8.37361 5.5217 8.36634 5.80439Z"
      className={className}
    />
    <path
      d="M1.66701 4.00554H11.4634C11.842 4.00554 12.1492 3.67282 12.1492 3.26216C12.1492 2.85167 11.8421 2.51893 11.4634 2.51893H1.66701C1.28832 2.51893 0.981201 2.85165 0.981201 3.26216C0.981201 3.6728 1.28829 4.00554 1.66701 4.00554Z"
      className={className}
    />
    <path
      d="M5.36773 3.07716L5.56834 2.20982C5.59704 2.08608 5.7578 1.95029 5.87476 1.95029H7.43613C7.55336 1.95029 7.71385 2.08579 7.74255 2.20982L7.94316 3.07716L9.2673 2.71947L9.06656 1.85213C8.88608 1.07195 8.17979 0.475586 7.43612 0.475586H5.87476C5.13109 0.475586 4.42478 1.07221 4.24432 1.85213L4.04358 2.71947L5.36773 3.07716Z"
      className={className}
    />
  </svg>
);

export {
  UploadFileIconSVG,
  DownloadAllFileIconSVG,
  IconSVG,
  SendDocumentIconSVG,
  IconDisabledSVG,
  SendDocumentDisabledIconSVG,
  FacilityProviderIconSVG,
  DoctorProviderIconSVG,
  DeleteIconSVG,
};
